/**
 * Auth state — Zustand store. Pojedyncze źródło prawdy o:
 *  - kim jest zalogowany użytkownik (z Firebase Auth)
 *  - do której rodziny należy
 *  - czy onAuthStateChanged już rozegrał (authReady)
 *  - przejściowych danych (Google name prefill, register data dla register-family)
 */
import { create } from 'zustand';

export interface AuthUser {
  uid: string;
  email: string;
  name: string;
}

export interface FamilyMember {
  name: string;
  email: string;
}

export interface Family {
  id: string;
  name: string;
  inviteCode?: string;
  inviteCodeExpiresAt?: Date | null;
  creatorId?: string;
  members: Record<string, FamilyMember>;
}

interface AuthStore {
  user: AuthUser | null;
  family: Family | null;
  authReady: boolean;
  /** Imię z Google profile dla prefill register flow */
  googleNamePrefill: string | null;
  /** Dane rejestracji email/hasło — przekazywane do register-family */
  pendingRegistration: { name: string; email: string } | null;

  setUser: (u: AuthUser | null) => void;
  setFamily: (f: Family | null) => void;
  setAuthReady: (ready: boolean) => void;
  setGoogleNamePrefill: (name: string | null) => void;
  setPendingRegistration: (data: { name: string; email: string } | null) => void;
  reset: () => void;
}

export const useAuthStore = create<AuthStore>((set) => ({
  user: null,
  family: null,
  authReady: false,
  googleNamePrefill: null,
  pendingRegistration: null,

  setUser: (user) => set({ user }),
  setFamily: (family) => set({ family }),
  setAuthReady: (authReady) => set({ authReady }),
  setGoogleNamePrefill: (googleNamePrefill) => set({ googleNamePrefill }),
  setPendingRegistration: (pendingRegistration) => set({ pendingRegistration }),
  reset: () => set({ user: null, family: null, googleNamePrefill: null, pendingRegistration: null }),
}));
